// Onboarding completion is stored in a cookie (not localStorage) because
// App.jsx wipes localStorage on browser close — a cookie guarantees the
// tour is shown exactly once per user, ever.
const COOKIE_PREFIX = "sulhafa_onboarding_v1_";
const TEN_YEARS_IN_DAYS = 3650;

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
};

const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

export const hasCompletedOnboarding = (userId) => {
  if (!userId) return true; // never nag logged-out visitors
  return getCookie(COOKIE_PREFIX + userId) === "1";
};

export const completeOnboarding = (userId) => {
  if (!userId) return;
  setCookie(COOKIE_PREFIX + userId, "1", TEN_YEARS_IN_DAYS);
};
